module.exports = __webpack_public_path__ + "media/6.4c6c4378.mp3";